export default {
    tipList: {
        en: [
            {
                title: 'Why Your Instagram Video Downloads Are Low Quality – Causes & Solutions',
                desc: 'Discover why Instagram video downloads often appear low quality and how to fix it. Learn tips for high-definition downloads using reliable tools like InstaSave for fast, clear, and smooth video saving.',
                url: 'https://instasaves.io/why-instagram-video-downloader-low-quality-causes/',
                date: '2025-09-16',
                poster: require('@/assets/downloadTips.webp'),
                name: 'tip-1',
            },
            {
                title: 'Permanently Save Instagram Stories Before They Disappear',
                desc: 'Save and download Instagram Stories easily with InstaSave. Keep personal memories, creative content, and professional resources safe and accessible anytime.',
                url: 'https://instasaves.io/save-instagram-stories-before-they-disappear/',
                date: '2025-10-10',
                poster: require('@/assets/blog-2-1.webp'),
                name: 'blog-2',
            },
            {
                title: 'How to Fix InstaSave When It\'s Not Working Properly？',
                poster: require('@/assets/blog-3-1.webp'),
                desc: "InstaSave stopped saving videos or photos? Here's how to get it back on track and continue downloading Instagram reels, stories, and posts with ease.",
                name: 'blog-3',
                url: 'https://instasaves.io/instasave-fix-guide/',
                date:"2025-10-13",
            },
            {
                title: 'InstaSave vs FastSave: Which Instagram Downloader is Better?',
                poster: require('@/assets/blog-4-1.webp'),
                desc: "Compare InstaSave vs FastSave to find the best Instagram downloader. Discover features, quality, speed, and ease of use differences to make the right choice.",
                name: 'blog-4',
                url: 'https://instasaves.io/instasave-vs-fastsave/',
                date:"2025-10-24",
            },
            {
                title: 'Is It Possible to Download an Instagram Private Video',
                poster: require('@/assets/blog-5.webp'),
                desc: "Explore the possibilities and limitations of downloading Instagram private videos. Learn about technical methods.",
                name: 'en-blog5',
                url: 'https://instasaves.io/download-instagram-private-video/',
                date:"2025-11-20",
            },
            {
                title: 'What Is an Instagram Private Account Viewer?',
                poster: require('@/assets/blog-6.webp'),
                desc: "Understanding Instagram private account viewers and InstaSave functionality. Privacy implications, technical limitations, and alternative viewing methods explained.",
                name: 'en-instagram-private-account-viewer',
                url: '/instagram-private-account-viewer/',
                date: "2025-11-27",
            },
            {
                title: 'SnapInsta vs InstaSave: Which Instagram Downloader Is Better',
                poster: require('@/assets/blog-7.webp'),
                desc: "SnapInsta and InstaSave Instagram downloaders reviewed for speed, media support, privacy, and usability to determine the best tool for content saving.",
                name: 'en-snapinsta-vs-instasave-instagram-downloader',
                url: '/snapinsta-vs-instasave-instagram-downloader/',
                date: "2026-02-03",
            },
            {
                title: 'How InstaSave Complements GBWhatsApp’s Advanced Sharing Features',
                poster: require('@/assets/blog-8.webp'),
                desc: "Learn how InstaSave and GBWhatsApp work together to download Instagram videos and share them in original quality without compression. Complete save-and-share workflow guide.",
                name: 'en-instasave-to-gbwhatsapp-guide',
                url: '/instasave-to-gbwhatsapp-guide/',
                date: "2026-02-26",
            },
            {
                title: 'Is It Safe to Download Instagram Videos? A Practical Guide for Users',
                poster: require('@/assets/blog-9.webp'),
                desc: "You may wonder if it's safe to download Instagram videos. Here we made an explaination. Learn the risks and try Instasave to download Instagram videos, photos, reels and others.",
                name: 'en-is-it-safe-to-download-instagram-videos',
                url: '/is-it-safe-to-download-instagram-videos/',
                date: "2026-02-26",
            },
            {
                title: 'Why Is My Instagram Downloaded Video Blurry? Fixes That Work',
                poster: require('@/assets/blog-cover-instagram-blurry.webp'),
                desc: 'Downloaded an Instagram video and it looks blurry? Find out why quality drops and what you can actually do to get the clearest version.',
                name: 'instagram-downloaded-video-blurry',
                url: '/instagram-downloaded-video-blurry/',
                type: 'blog',
                date: '2026-09-20',
            },
            {
                title: 'Instagram Video vs Reels Download: What’s the Difference?',
                poster: require('@/assets/blog-cover-video-vs-reels.webp'),
                desc: 'Not sure whether you’re downloading an Instagram Reel or a regular video? Learn the difference, which links work, and what changes when you save each type.',
                name: 'instagram-video-vs-reels-download',
                url: '/instagram-video-vs-reels-download/',
                type: 'blog',
                date: '2026-09-20',
            },
            {
                title: 'How to Download Instagram Videos Without an Account',
                poster: require('@/assets/blog-cover-download-without-account.webp'),
                desc: 'Want to download a public Instagram video without logging in? Learn what works, what doesn’t, and how to save videos using your browser.',
                name: 'download-instagram-videos-without-account',
                url: '/download-instagram-videos-without-account/',
                type: 'blog',
                date: '2026-09-20',
            },
            {
                title: 'How to Download Instagram Reels on iPhone and Android',
                poster: require('@/assets/blog-cover-reels-iphone-android.webp'),
                desc: 'Learn how to download Instagram Reels on iPhone and Android, where the files are saved, and what to do when the download option is missing.',
                name: 'download-instagram-reels-iphone-android',
                url: '/download-instagram-reels-iphone-android/',
                type: 'blog',
                date: '2026-09-20',
            },
        ],
    },
};
